import { SANR_DISCORD } from '@/shared/constants/links';
import ExternalLink from '@/shared/ui/ExternalLink';
import Button from '@/shared/ui/Button';
import oopsImage from './oops.png';

export default function UiError() {
  return (
    <div className="flex min-h-screen w-full flex-col items-center justify-center bg-background-main text-center max-md:px-s">
      <img
        className="h-49.75 w-79 max-md:h-41.5 max-md:w-65.5"
        src={oopsImage}
      />
      <div className="text-h1 leading-12 font-bold text-gray-text max-md:max-w-65.5 max-md:text-h2">
        Oops!
      </div>
      <div className="text-h1 leading-12 font-bold text-gray-text max-md:max-w-65.5 max-md:text-h2">
        Seems like something went wrong
      </div>
      <div className="mt-l text-body-lg text-gray-text max-md:max-w-65.5">
        Let us know about the issue in our{' '}
        <ExternalLink
          className="inline! text-blue-default underline"
          href={SANR_DISCORD}
        >
          Discord
        </ExternalLink>
        .<br />
        We will look into it ASAP.
      </div>
      <div className="mt-3xl">
        <Button onClick={() => window.location.reload()} size="lg">
          Refresh
        </Button>
      </div>
    </div>
  );
}
